import data from './Wakeboarding.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function Wakeboarding() {

  return WithPage(data, "wakeboarding")

}

